import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="page-container">
      <mars-card no-padding [disabled]="true">
        <mars-card-header>
          <h3 class="semibold m-0" translate>Page not found</h3>
        </mars-card-header>

        <mars-card-content>
          <p class="mb-2" translate>
            The link you clicked may be broken of the page you are looking for has been removed
          </p>

          <p translate>
            If you think this is an issue please contact
            <a href="https://examsoft.com/contact#support">ExamSoft Support</a>, otherwise visit the
            <a replaceUrl [routerLink]="['/']">Home Page</a> to continue.
          </p>
        </mars-card-content>
      </mars-card>
    </div>
  `,
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {}
